// src/components/Tutorial/Examples/ReviewsPage.js
import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { RateReview } from '@mui/icons-material';
import '../Tutorial.css';

const ReviewsPage = () => {
  return (
    <Box className="example-container">
      <Paper elevation={3} className="tutorial-paper-wide">
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Your Reviews
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Manage and browse through your creator reviews
        </Typography>
        
        <Button
          variant="contained"
          startIcon={<RateReview />}
          className="golden-highlight"
          sx={{
            px: 3,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            bgcolor: 'primary.main',
            border: '2px solid #FFD700',
            boxShadow: '0 0 10px rgba(255, 215, 0, 0.5)',
            '&:hover': {
              bgcolor: 'primary.dark',
              border: '2px solid #FFD700',
              boxShadow: '0 0 15px rgba(255, 215, 0, 0.7)',
            }
          }}
        >
          Review My Subscriptions
        </Button>
      </Paper>
    </Box>
  );
};

export default ReviewsPage;
